import { MYTHOLOGIES } from '@/utils/mythologies';

export const MythologyGrid = ({ onSelect, selected }) => {
  return (
    <div>
      <div data-testid="landing-mythologies-grid" className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5">
        {MYTHOLOGIES.slice(0, 6).map((m) => {
          const isSelected = selected === m.key;
          const previewDeities = m.deities.slice(0, 3).map((d) => d.name).join(', ');
          const rest = m.deities.length > 3 ? ` +${m.deities.length - 3}` : '';
          return (
            <button
              key={m.key}
              type="button"
              data-testid={`mythology-card-${m.key.toLowerCase().replace(/[^a-z]/g, '')}`}
              onClick={() => onSelect && onSelect(m.key)}
              className={`tl-mythology-card text-left rounded-tlLg border p-5 min-h-[130px] outline-none focus-visible:ring-2 focus-visible:ring-tl-gold focus-visible:ring-offset-2 ${
                isSelected
                  ? 'border-tl-purple bg-tl-purpleLight/60 text-slate-900'
                  : 'border-slate-200 bg-white hover:border-tl-purple text-slate-900'
              }`}
            >
              <div className="text-[26px] leading-none">{m.flag}</div>
              <div className="mt-3 text-[14px] font-semibold">{m.key}</div>
              <div className="text-[11px] text-slate-500 mt-1">
                {previewDeities}{rest}
              </div>
            </button>
          );
        })}
      </div>
      <p className="mt-4 text-[11px] text-slate-500">
        + Celtic, Polynesian, Aztec, African/Yoruba, Roman traditions — with dozens of deities to choose from
      </p>
    </div>
  );
};
